import { ButtonLink, Stack, StackItem } from '@asgard/ui-library';

import { faArrowRight } from '@fortawesome/pro-solid-svg-icons';
import { CardHighlight01 } from 'components/CardHighlight01/CardHighlight01';
import { CardHighlight04 } from 'components/CardHighlight04/CardHighlight04';
import { PageContentContainer } from 'components/layout/Page.styled';
import HtmlTrans from 'components/shared/HtmlTrans';
import { useI18n } from 'hooks/useI18n';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { APP_URLS, getAppUrl } from 'utils/app-urls';
import { getPublicPath } from 'utils/paths';
import { TalentIntro } from '../components/intro/TalentIntro';
import { TalentToolsStyles } from './TalentTools.styles';

export const TalentTools: React.FC = () => {
  const { t } = useI18n('talent-new');
  const { locale } = useRouter();

  return (
    <TalentToolsStyles.Root>
      <Stack direction="column" gap="4xl">
        <PageContentContainer containerSize="xl">
          <TalentIntro
            className="intro"
            title={t('talent-new.tools.title')}
            desc={t('talent-new.tools.desc')}
          />

          <Stack direction="column" gap="4xl">
            <CardHighlight01>
              <TalentToolsStyles.CardContent1 align="center">
                <img
                  loading="lazy"
                  src={getPublicPath(
                    `/images/talent-new/talent-new-tools-feature1.webp`
                  )}
                  alt=""
                />

                <StackItem>
                  <h3>{t(`talent-new.tools.feature1.card-title`)}</h3>
                  <HtmlTrans
                    ns="talent-new"
                    i18nKey={`talent-new.tools.feature1.card-content`}
                  />

                  <Link
                    href={getAppUrl(APP_URLS.salaryBenchmark, locale)}
                    passHref
                  >
                    <ButtonLink
                      schema="brand1"
                      variant="hard"
                      endIcon={faArrowRight}
                      size="s"
                      label={t('talent-new.tools.feature1.cta')}
                    />
                  </Link>
                </StackItem>
              </TalentToolsStyles.CardContent1>
            </CardHighlight01>

            <Stack>
              <CardHighlight04 className="half">
                <TalentToolsStyles.CardContent2>
                  <img
                    loading="lazy"
                    src={getPublicPath(
                      `/images/talent-new/talent-new-tools-feature2.webp`
                    )}
                    alt=""
                  />

                  <h3>{t('talent-new.tools.feature2.card-title')}</h3>
                  <HtmlTrans
                    ns="talent-new"
                    i18nKey={'talent-new.tools.feature2.card-content'}
                  />
                  <Link
                    href={getAppUrl(APP_URLS.mantechcar25, locale)}
                    passHref
                  >
                    <ButtonLink
                      schema="brand1"
                      variant="hard"
                      endIcon={faArrowRight}
                      size="s"
                      label={t('talent-new.tools.feature2.cta')}
                    />
                  </Link>
                </TalentToolsStyles.CardContent2>
              </CardHighlight04>

              <CardHighlight04 className="half">
                <TalentToolsStyles.CardContent2>
                  <img
                    loading="lazy"
                    src={getPublicPath(
                      `/images/talent-new/talent-new-tools-feature3.webp`
                    )}
                    alt=""
                  />

                  <h3>{t('talent-new.tools.feature3.card-title')}</h3>
                  <HtmlTrans
                    ns="talent-new"
                    i18nKey={'talent-new.tools.feature3.card-content'}
                  />
                  <Link
                    href={getAppUrl(APP_URLS.helpingJuniors, locale)}
                    passHref
                  >
                    <ButtonLink
                      schema="brand1"
                      variant="hard"
                      endIcon={faArrowRight}
                      size="s"
                      label={t('talent-new.tools.feature3.cta')}
                    />
                  </Link>
                </TalentToolsStyles.CardContent2>
              </CardHighlight04>
            </Stack>

            <CardHighlight01>
              <TalentToolsStyles.CardContent1 align="center">
                <img
                  loading="lazy"
                  src={getPublicPath(
                    `/images/talent-new/talent-new-tools-feature4.webp`
                  )}
                  alt=""
                />

                <StackItem>
                  <h3>{t(`talent-new.tools.feature4.card-title`)}</h3>
                  <HtmlTrans
                    ns="talent-new"
                    i18nKey={`talent-new.tools.feature4.card-content`}
                  />

                  <Link
                    href={getAppUrl(APP_URLS.portalV2Settings, locale)}
                    passHref
                  >
                    <ButtonLink
                      schema="brand1"
                      variant="hard"
                      endIcon={faArrowRight}
                      size="s"
                      label={t('talent-new.tools.feature1.cta')}
                    />
                  </Link>
                </StackItem>
              </TalentToolsStyles.CardContent1>
            </CardHighlight01>
          </Stack>
        </PageContentContainer>
      </Stack>
    </TalentToolsStyles.Root>
  );
};

export default TalentTools;
